import { DateTime } from 'luxon';
import { CabinetService } from 'src/app/core/services/cabinet.service';
import { PrintService } from 'src/app/core/services/print.service';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { PatientService } from 'src/app/core/services/patient.service';
import { untilDestroy } from '@ngrx-utils/store';
import { filter, take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { RecordService } from 'src/app/core/services/record.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintComponent implements OnInit, OnDestroy {

  user$ = this.authService.user$.pipe(filter(user => !!user));
  cabinet$ = this.cabinetService.cabinet$.pipe(filter(cabinet => !!cabinet));
  patient$ = this.patientService.patient$.pipe(filter(patient => !!patient));
  records$ = this.recordService.records$.pipe(filter(records => !!records));
  today = DateTime.fromJSDate(new Date()).toObject();
  date = DateTime.fromJSDate(new Date()).toFormat('dd/LL/yyyy');
  hour = DateTime.fromJSDate(new Date()).toFormat('H:mm');

  constructor(
    private authService: AuthenticationService,
    private cabinetService: CabinetService,
    private patientService: PatientService,
    private recordService: RecordService,
    private printService: PrintService
  ) { }

  ngOnInit(): void {
    // combineLatest([
    //   this.account$,
    //   this.cabinet$,
    //   this.patient$,
    //   this.records$
    // ]).pipe(
    //   take(1),
    //   untilDestroy(this)
    // ).subscribe(([account, cabinet, patient, records]) => {
    //   console.warn(account, cabinet, patient, records);
    //   this.printService.onDataReady();
    // });
  }
  ngOnDestroy() {}

  getAgeFromBirthDate(date: Date): string {
    if (!date) {
      return;
    }

    const enAge = this.patientService.getAgeFromBirthDate(date);
    const roAge = enAge
      .replace('years', 'ani')
      .replace('months', 'luni')
      .replace('days', 'zile')
      .replace('year', 'an')
      .replace('month', 'luna')
      .replace('day', 'zi');
    return roAge;
  }

  getFormattedCreatedAt(createdAt: number): string {
    return createdAt ? DateTime.fromMillis(createdAt).toFormat('dd.LL.yyyy HH:mm') : null;
  }

}
